import React from "react";
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import projectList from '../../assets/static/projects.json';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import classes from './Project.module.css';
import {Icon} from "@material-ui/core";

const Projects  = () => (
	<div>
		<h3>Experience</h3>
		<Timeline align="left">
			{projectList.projects.map(project => (
				<TimelineItem key={project.id}>
					<TimelineOppositeContent style={{flex: '0 1 0'}}/>
					<TimelineSeparator>
							<TimelineDot variant="outlined" className={classes.TimelineDot}/>
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent>
						<Typography className={classes.Role}>{project.role} - {project.company}{project.project && " - " + project.project}</Typography>
						<Typography className={classes.Duration}> {project.duration} - {project.location} </Typography>
						<Typography className={classes.Company}></Typography>
						<Typography className={classes.Description}>{project.description}</Typography>
						<List className={classes.ResponsibilitiesList}>
							{project.responsibilities && project.responsibilities.map((responsibility, index) =>
								<ListItem key={index} className={classes.ResponsibilitiesListItem}>
									<ListItemIcon className={classes.ResponsibilitiesListItemIcon}>
										<Icon>stop</Icon>
									</ListItemIcon>
									<ListItemText classes={{primary:classes.ResponsibilitiesListItemText}} primary={responsibility} />
								</ListItem>
							)}
						</List>
					</TimelineContent>
				</TimelineItem>
			))}
		</Timeline>
	</div>
);

export default Projects;
